export default {
  operatedBy: 'Opéré par {{unit}}',
  btnBook: 'Réserver',
  shuttleFull: 'Ce trajet est entièrement réservé',
  freeSeats: {
    seat: '{{seats}} Siège restant',
    seats: '{{seats}} Sièges restants', 
  }
};